<template>
  <b-card style="padding:40px;">
    <loading
      :active.sync="isLoading"
      :can-cancel="true"
      :is-full-page="fullPage"
    ></loading>

    <h5><b>MONTHLY FORECAST (SUBMITTED)</b></h5>
    <hr />

    <b-row>
      <b-col md="4">
        <b-form-group>
          <label :for="`input-name`">Full Name</label>
          <b-form-input
            v-model="form.name"
            :id="`input-name`"
            :type="`text`"
            readonly
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="4">
        <b-form-group>
          <label :for="`input-date`">Date</label>
          <b-form-input
            v-model="form.date"
            :id="`input-date`"
            :type="`text`"
            readonly
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="4">
        <b-form-group>
          <label :for="`input-companyName`">Company Name</label>
          <b-form-input
            v-model="form.company"
            :id="`input-companyName`"
            :type="`text`"
            readonly
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col md="4">
        <b-form-group>
          <label :for="`input-roles`">Roles</label>
          <b-form-input
            v-model="form.role"
            :id="`input-roles`"
            :type="`text`"
            readonly
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="4">
        <b-form-group>
          <label :for="`input-roles`">Month</label>
          <b-form-input :value="getMonth(form.month)" readonly />
        </b-form-group>
      </b-col>

      <b-col md="4">
        <b-form-group>
          <label :for="`input-roles`">Year</label>
          <b-form-input v-model="form.year" readonly />
        </b-form-group>
      </b-col>
    </b-row>

    <div>
      <b-tabs content-class="mt-3">
        <b-tab title="Week 1" active>
          <TableMonthlyForecastView :fields="fields" :items="items.data1" />
        </b-tab>
        <b-tab title="Week 2">
          <TableMonthlyForecastView :fields="fields" :items="items.data2" />
        </b-tab>
        <b-tab title="Week 3">
          <TableMonthlyForecastView :fields="fields" :items="items.data3" />
        </b-tab>
        <b-tab title="Week 4">
          <TableMonthlyForecastView :fields="fields" :items="items.data4" />
        </b-tab>
        <b-tab title="Week 5">
          <TableMonthlyForecastView :fields="fields" :items="items.data5" />
        </b-tab>
      </b-tabs>
    </div>

    <b-row align="right">
      <b-col>
        <b-button variant="primary" size="sm" @click="onClickBack">
          BACK </b-button
        >&nbsp;&nbsp;&nbsp;
        <b-button variant="primary" size="sm" @click="onClickInvoice">
          DOWNLOAD FORECAST
        </b-button>
        &nbsp;&nbsp;&nbsp;
        <b-button
          variant="primary"
          size="sm"
          v-if="accLvl != '1'"
          @click="onClickChange"
          >EDIT
        </b-button>
        &nbsp;&nbsp;&nbsp;
        <b-button
          variant="danger"
          size="sm"
          v-if="accLvl != '1'"
          @click="onClickDeleteMF"
          >DELETE
        </b-button>
      </b-col>
    </b-row>

    <b-modal id="delete-mf" title="Delete Confirmation">
      <p>
        <b>Are you sure you want to delete ?</b>
      </p>

      <template v-slot:modal-footer="{ close }">
        <b-button variant="primary" size="sm" @click="close()">
          CLOSE
        </b-button>
        <b-button variant="danger" size="sm" @click="onClickDeleteMFConfirm">
          Delete
        </b-button>
      </template>
    </b-modal>
  </b-card>
</template>

<script>
import TableMonthlyForecastView from "@/table/user/monthlyForecast/TableMonthlyForecastView";
import moment from "moment";
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  data() {
    return {
      items: {
        data1: [],
        data2: [],
        data3: [],
        data4: [],
        data5: []
      },

      // Loading
      isLoading: false,
      fullPage: true,

      form: {
        name: "",
        date: "",
        comp_name: "",
        role: "",
        month: "",
        year: "",
        type: ""
      },
      fields: [
        {
          label: "No",
          key: "no",
          sortable: false
        },
        {
          label: "Product Name",
          key: "name",
          sortable: true
        },
        {
          label: "Quantity",
          key: "quantity",
          sortable: true
        },
        {
          label: "Quantity Type",
          key: "quantity_type",
          sortable: true
        }
      ],

      accLvl: null
    };
  },
  created() {
    this.accLvl = this.$store.getters.getAccessLevel;

    this.showMF();
    this.form.type =
      parseInt(this.$route.query.pro_cat) === 1 ? "UHT" : "Pasteurized";
  },
  methods: {
    getMonth(month) {
      switch (parseInt(month)) {
        case 1:
          return "January";
        case 2:
          return "February";
        case 3:
          return "March";
        case 4:
          return "April";
        case 5:
          return "May";
        case 6:
          return "June";
        case 7:
          return "July";
        case 8:
          return "August";
        case 9:
          return "September";
        case 10:
          return "October";
        case 11:
          return "November";
        case 12:
          return "December";
      }
    },

    // Go back
    onClickBack() {
      if (parseInt(this.accLvl) === 1) {
        let path = "";
        if (this.$route.query.type && this.$route.query.type === "sub") {
          path = `home_dealer_admin?state=${this.$route.query.state}&stockist_id=${this.$route.query.upline}&tab=5&page=${this.$route.query.page}&filter=${this.$route.query.filter}&date=${this.$route.query.date}&name=${this.$route.query.name}&outlet_name=${this.$route.query.outlet_name}&email=${this.$route.query.email}`;
        } else {
          path = `/monthly_forecast?filter=${this.$route.query.filter}&page=${this.$route.query.page}&name=${this.$route.query.name}`;
        }

        this.$router.push({
          path: path
        });
      } else {
        if (
          this.$route.query.from !== undefined &&
          this.$route.query.from === "created"
        ) {
          this.$router.push({
            path: `mf_user`
          });
        } else {
          this.$router.go(-1);
        }
      }
    },

    showMF() {
      this.$store
        .dispatch("showMF", {
          fc_id: this.$route.query.id,
          category: 3
        })
        .then(res => {
          if (res.data.response.code === 100) {
            // get id
            this.form.id = res.data.data.fc_id;
            this.form.name = res.data.data.userdetails.name;
            this.form.date = moment(res.data.data.date).format("DD/MM/YYYY");
            this.form.company = res.data.data.userdetails.company;
            this.form.role = res.data.data.userdetails.role_details.desc;
            // get month
            this.form.month = res.data.data.month;
            // get year
            this.form.year = res.data.data.year;

            if (
              res.data.data.fc_week.length > 1 ||
              res.data.data.fc_week !== undefined
            ) {
              let week = res.data.data.fc_week;
              week.forEach(item => {
                // Week 1
                if (item.week === 1) {
                  let week1 = [];
                  item.pro_stock.forEach(item2 => {
                    week1.push({
                      isActive: true,
                      pro_stock_id: item2.pro_stock_id,
                      name: item2.product.name,
                      sku: item2.product_id,
                      quantity: item2.quantity,
                      quantity_type: item2.quantity_type === 1 ? "Pcs" : "Ctn",
                      index: item2.index,
                      action: "fas fa-user"
                    });
                  });
                  this.items.data1 = week1;
                }

                // Week 2
                if (item.week === 2) {
                  let week2 = [];
                  item.pro_stock.forEach(item2 => {
                    week2.push({
                      isActive: true,
                      pro_stock_id: item2.pro_stock_id,
                      name: item2.product.name,
                      sku: item2.product_id,
                      quantity: item2.quantity,
                      quantity_type: item2.quantity_type === 1 ? "Pcs" : "Ctn",
                      index: item2.index,
                      action: "fas fa-user"
                    });
                  });
                  this.items.data2 = week2;
                }

                // Week 3
                if (item.week === 3) {
                  let week3 = [];
                  item.pro_stock.forEach(item2 => {
                    week3.push({
                      isActive: true,
                      pro_stock_id: item2.pro_stock_id,
                      name: item2.product.name,
                      sku: item2.product_id,
                      quantity: item2.quantity,
                      quantity_type: item2.quantity_type === 1 ? "Pcs" : "Ctn",
                      index: item2.index,
                      action: "fas fa-user"
                    });
                  });
                  this.items.data3 = week3;
                }

                // Week 4
                if (item.week === 4) {
                  let week4 = [];
                  item.pro_stock.forEach(item2 => {
                    week4.push({
                      isActive: true,
                      pro_stock_id: item2.pro_stock_id,
                      name: item2.product.name,
                      sku: item2.product_id,
                      quantity: item2.quantity,
                      quantity_type: item2.quantity_type === 1 ? "Pcs" : "Ctn",
                      index: item2.index,
                      action: "fas fa-user"
                    });
                  });
                  this.items.data4 = week4;
                }

                // Week 5
                if (item.week === 5) {
                  let week5 = [];
                  item.pro_stock.forEach(item2 => {
                    week5.push({
                      isActive: true,
                      pro_stock_id: item2.pro_stock_id,
                      name: item2.product.name,
                      sku: item2.product_id,
                      quantity: item2.quantity,
                      quantity_type: item2.quantity_type === 1 ? "Pcs" : "Ctn",
                      index: item2.index,
                      action: "fas fa-user"
                    });
                  });
                  this.items.data5 = week5;
                }
              });
            }
          }
        });
    },

    onClickChange() {
      this.$router.push({
        path: `mf_edit?id=${this.$route.query.id}&type=edit`
      });
    },

    // Download Invoice
    onClickInvoice() {
      this.isLoading = true;
      this.$store
        .dispatch("getInvoice", {
          category: this.$route.query.cat,
          stock_id: this.$route.query.id
        })
        .then(res => {
          if (res.data.response.code === 100) {
            this.isLoading = false;
            window.open(
              `${process.env.VUE_APP_BASE_URL}/${res.data.data.path}`,
              "_blank"
            );
            // window.open(`https://azizazri.com/${res.data.data.path}`, "_blank");
          }
        });
    },
    onClickDeleteMF() {
      this.$bvModal.show("delete-mf");
    },
    onClickDeleteMFConfirm() {
      this.$store.dispatch("deleteMF", this.$route.query.id).then(res => {
        if (res.data.response.code === 1) {
          this.$bvModal.hide("delete-mf");
          this.onClickBack();
        }
      });
    }
  },
  components: {
    TableMonthlyForecastView,
    Loading
  }
};
</script>
<style lang="css" scoped></style>
